export const CART_POPUP = 'js-cart-popup';

export const CART_POPUP_CHECKOUT_BUTTON = 'js-cart-popup__checkout-button';

export const CART_COUNT = 'js-cart-count';
